import type { $Fetch } from 'ofetch';
import { BaseClient } from '@shared/clients/BaseClient.ts';
import type { Logger, Variation } from '@shared/types/types';
import type { AsyncResult } from '@shared/types/utilities';

const DEFAULT_TIMEOUT_MS = 160;

export type CrocotileFeature = 'tilelist' | 'tilelist-lite' | 'topic-page';

export class CrocotileClient extends BaseClient {
    private readonly ottoFeature: string;

    constructor({
        fetchClient,
        logger,
        baseURL,
        timeout = DEFAULT_TIMEOUT_MS,
        feature = 'tilelist',
    }: {
        fetchClient: $Fetch;
        logger: Logger;
        baseURL?: string;
        timeout?: number;
        feature?: CrocotileFeature;
    }) {
        super(baseURL, fetchClient, logger, timeout);
        this.ottoFeature = `${feature}@RepTile-Dundee`;
    }

    async getVariations(variationIds: string[]): AsyncResult<Variation[]> {
        if (!variationIds.length) {
            return { state: 'success', payload: [] };
        }

        const query = { variationIds: variationIds.join(',') };
        const headers: Record<string, string> = {
            accept: 'application/json',
            'crocotile-version': '2',
            'otto-feature': this.ottoFeature,
        };

        try {
            const payload = await this.fetch<Variation[]>('/crocotile/tile/data', { query, headers });
            return { state: 'success', payload };
        } catch (_err: unknown) {
            return { state: 'error' };
        }
    }

    async getVariation(id: Variation['variationId']): AsyncResult<Variation> {
        const headers: Record<string, string> = {
            'crocotile-version': '2',
            'otto-feature': this.ottoFeature,
        };

        try {
            const payload = await this.fetch<Variation>(`/crocotile/tile/data/${id}`, { headers });
            return { state: 'success', payload };
        } catch (_err: unknown) {
            return { state: 'error' };
        }
    }
}
